<template>    
 <v-container fill-height justify-start fluid>
     <v-layout>
         <v-flex md2>
        <AdminNav /> 
         </v-flex>
         <v-flex md10>       
        <router-view></router-view>        
         </v-flex>
     </v-layout>
 </v-container>
</template>

<script>
import {  mapActions } from 'vuex'
import AdminNav from '@/components/admin/AdminNav'
export default {
    name: 'Admin',
    data() {
        return {
            
        }
    },
    components: {
        AdminNav
    },
    methods: {
        ...mapActions('title',['updateTitle'])
    },
    created()
    {
        this.updateTitle('Administracja systemem')
    }
}
</script>

<style>

    .admin .main {
        margin-left: 200px;
        padding: 0px 10px;
    }
</style>
